export const HOST_HUB_WELCOME_DIALOG_NUX_KEY = "hostHubWelcomeDialog";

// Statsig dynamic config carrying the host hub NUX object payload.
export const HOST_HUB_NUX_DYNAMIC_CONFIG_NAME = "web_2_nux";

// Key inside `web_2_nux` that gates the host hub NUX ({ enabled, expires }).
export const HOST_HUB_NUX_CONFIG_KEY = "host_hub_coachmark";
